import { ENDPOINTS } from "../../endpoints";

export enum RoomType {
  Bedroom = "bed",
  LivingRoom = "living",
  Kitchen = "kitchen",
  Bathroom = "bathroom",
  HomeOffice = "home_office",
  DiningRoom = "dining",
  KidsRoom = "kids_room",
  Outdoor = "outdoor",
}

export enum RoomStyle {
  Standard = "standard",
  Modern = "modern",
  Scandinavian = "scandinavian",
  Industrial = "industrial",
  Midcentury = "midcentury",
  Luxury = "luxury",
  Coastal = "coastal",
  Farmhouse = "farmhouse",
}

export type RoomTypeOption = { id: RoomType; name: string };
export type RoomStyleOption = { id: RoomStyle; name: string };

export type RoomProperties = {
  room_types: RoomTypeOption[];
  room_styles: RoomStyleOption[];
};

export const getRoomProperties = async (): Promise<RoomProperties> => {
  try {
    const response = await fetch(ENDPOINTS.ROOM_PROPERTIES, {
      method: "GET",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch room properties");
    }

    const data = (await response.json()) as RoomProperties;
    return data;
  } catch (error) {
    console.error("Error fetching room properties:", error);
    throw error;
  }
};
